




















































import {Component, Vue} from 'vue-property-decorator';
import Klokjes from '@/components/Klokjes.vue';
import ContentService from '@/services/ContentService';
import LocaleService from '@/services/LocaleService';
import {default as GameLogic, Hotspot, HotspotOption} from "../services/GameLogic";
import {DelierState} from "../store/store";
import LocaleText from "../components/LocaleText.vue";
import Animations from "../services/Animations";

interface StringMap { [name: string]: string; }

class ComputerButton {
    public hotspot: Hotspot = Hotspot.NONE;
    public key: string = "";
    public action: string = "";
    public label: string = "";
}

const DOS:string = "mobielecomputerdos";

function animateEnterResults(instance:ComputerMenu):void {
    instance.$data.inTransition = true;
    Vue.nextTick().then(() => {
        Animations.slideToLeft(instance.$refs.menu, .5).then(() => {
            instance.$data.inTransition = false;
        });
        //Animations.fadeHide(this.$refs.result);
        Animations.slideFromRight(instance.$refs.result, .75);
    });
}

function animateExitResults(instance:ComputerMenu):void {
    instance.$data.inTransition = true;
    Vue.nextTick().then(() => {
        Animations.slideFromLeft(instance.$refs.menu, .75);
        Animations.slideToRight(instance.$refs.result, .5).then(() => {
            instance.$data.currentResult = '';
            instance.$store.state.currentHotspot = Hotspot.NONE;
            instance.$store.state.currentOption = HotspotOption.NONE;
            instance.$data.confirmDos = false;
            instance.$data.inTransition = false;
        });
    });
}

function animateExitDosResults(instance:ComputerMenu):void {

    // animateExitResults wil niet werken. De timing zorgt dat het menu verdwijnt zodra je er binnen komt
    // Daarom deze aparte functie, speciaal voor de DOS uitzondering

    instance.$data.inTransition = true;
    instance.$data.confirmDos = false;

    Vue.nextTick()
        .then(() => {
            Animations.slideToRight(instance.$refs.result, .5);
            return Animations.slideFromLeft(instance.$refs.menu, .75);
        })
        .then(() => {
            instance.$data.currentResult = '';
            instance.$store.state.currentHotspot = Hotspot.NONE;
            instance.$store.state.currentOption = HotspotOption.NONE;
            return Vue.nextTick();
        })
        .then(() => {
            instance.$data.inTransition = false;
        })
}

@Component({
    data() { return { currentResult: '', inTransition: false, confirmDos: false }},
    components: {LocaleText, Klokjes},
    computed: {
        getVpkRoute():string { return '/day/' + this.$route.params.day + '/nurse'; },
        computerButtons():ComputerButton[] {
            let state:DelierState = this.$store.state;
            let buttons:ComputerButton[] = [];
            let map:StringMap = <StringMap> ContentService.mobileButtonKeys;
            for(let key in ContentService.mobileButtonKeys) {
                let value:string = map[key];
                let button:ComputerButton = new ComputerButton();
                button.key = key;
                button.action = value;
                button.label = LocaleService.hotspotDisplayName(state, key);
                button.hotspot = GameLogic.getComputerButtonByName(state, key);
                buttons.push(button);
            }
            return buttons;
        },
        currentButton():ComputerButton {
            let state:DelierState = this.$store.state;
            let hotspot:Hotspot = state.currentHotspot;
            let button:ComputerButton = new ComputerButton();
            button.key = hotspot.icon;
            //button.action = value;
            button.label = LocaleService.hotspotDisplayName(state, hotspot.icon);
            button.hotspot = hotspot;
            return button;
        },
        getDateLabel():string {
            const situation = GameLogic.getSituationObject(this.$store.state).situation;
            return LocaleService.getValue(this.$store.state, [situation.name, situation.date.day].join('.'));
        },
        getTimeLabel():string {
            const situation = GameLogic.getSituationObject(this.$store.state).situation;
            return situation.date.time;
        },
        currentOptions():HotspotOption[] {
            return this.$store.state.currentHotspot.actions;
        },
        yesLabel():string {
            return LocaleService.getValue(this.$store.state, 'algemeen.bevesting.button.ja');
        },
        noLabel():string {
            return LocaleService.getValue(this.$store.state, 'algemeen.bevesting.button.nee');
        },
        showConfirm():boolean {
            return this.$data.confirmDos || (this.$data.currentResult == '' && this.$store.state.currentHotspot != Hotspot.NONE);
        },
        showResult():boolean {
            return this.$data.currentResult != '';// && this.$store.state.currentOption != HotspotOption.NONE;
        },
        getResultsTitle():string {
            let map:StringMap = <StringMap> ContentService.mobileButtonKeys;
            let key:string = map[this.$store.state.currentHotspot.name];
            return LocaleService.getValue(this.$store.state, 'algemeen.mobielecomputer.optie.' + key + '.title');
        },
        showDosButton():boolean {
            return this.$store.state.currentHotspot.name == DOS;
        }
    },
    methods: {
        handleButtonClicked(button:ComputerButton):void {
            //console.log(button);
            this.$store.state.currentHotspot = button.hotspot;
            if (button.hotspot.name == DOS) {
                this.$data.currentResult = LocaleService.hotspotMobileResult(this.$store.state, DOS);
                animateEnterResults(this);
            }
            else {
                this.$data.currentResult = '';
            }
            console.log(button.hotspot.name);
        },
        buttonEnabled: function(button:ComputerButton):boolean {
            return button.hotspot != Hotspot.NONE && button.hotspot.actions.length > 0;
        },
        handleOptionClicked(option:HotspotOption):void {
            if( this.$store.state.currentHotspot.name == DOS) {
                GameLogic.executeOption(this.$store.state, this.$store.state.currentHotspot, option);
                //this.$data.confirmDos = false;
                //animateExitResults(this);
                animateExitDosResults(this);
            }
            else {
                let result = LocaleService.hotspotMobileResult(this.$store.state, this.$store.state.currentHotspot.name);
                //console.log(result);
                GameLogic.executeOption(this.$store.state, this.$store.state.currentHotspot, option);
                if (result == '') {
                    this.$store.state.currentHotspot = Hotspot.NONE;
                    this.$store.state.currentOption = HotspotOption.NONE;
                } else {
                    this.$store.state.currentOption = option;
                    this.$data.currentResult = result;
                    animateEnterResults(this);
                }
            }
        },
        handleNoClicked():void {
            if (this.$store.state.currentHotspot.name == DOS) {
                this.$data.confirmDos = false;
            }
            else {
                this.$data.currentResult = '';
                this.$store.state.currentHotspot = Hotspot.NONE;
                this.$store.state.currentOption = HotspotOption.NONE;
                this.$data.confirmDos = false;
            }
        },
        handleCloseResult():void {
            if (this.$store.state.currentHotspot.name == DOS) {
                animateExitDosResults(this);
            }else {
                animateExitResults(this);
            }
        },
        handleDosConfirmClicked():void {
            this.$data.confirmDos = true;
        }
    },
    created():void {
        this.$store.commit('disableTip', 'algemeen.tutorial.tip4.text');
    }
})
export default class ComputerMenu extends Vue {
}
